const moment = require('moment');

const YEAR_FORMATS = [
  'YYYY-MM-DD',
  'YYYY-M-D',
  'YYYY/MM/DD',
  'YYYY/M/D',
  'MMM D, YYYY',
  'MMMM D, YYYY',
  'MMM D YYYY',
  'MMMM D YYYY',
  'MMM D, YY',
  'MMMM D, YY',
  'MMM D YY',
  'MMMM D YY',
  'D MMM YYYY',
  'D MMMM YYYY',
  'M/D/YYYY',
  'M/D/YY',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'M-D-YYYY',
  'M-D-YY',
  'MM-DD-YYYY',
  'MM-DD-YY',
  'M.D.YYYY',
  'M.D.YY',
  'MM.DD.YYYY',
  'MM.DD.YY',
];

const YEARLESS_FORMATS = [
  'M/D',
  'MM/DD',
  'M-D',
  'MM-DD',
  'M.D',
  'MM.DD',
  'MMM D',
  'MMMM D',
  'D MMM',
  'D MMMM',
];

const TRAILING_TIME = /[T\s]\d{1,2}:\d{2}(:\d{2})?(\.\d+)?\s*([ap]\.?m\.?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i;
const LEAP_REFERENCE_YEAR = 2024;
const MAX_YEARS_AHEAD = 8;

const normalize = (value) =>
  value
    .trim()
    .replace(/\s+/g, ' ')
    .replace(TRAILING_TIME, '')
    .replace(/\bsept\b/i, 'Sep')
    .replace(/([A-Za-z])\./g, '$1')
    .trim();

const nextOccurrence = (month, date, startOfToday) => {
  for (let year = startOfToday.year(); year <= startOfToday.year() + MAX_YEARS_AHEAD; year += 1) {
    const candidate = moment([year, month, date]);
    if (candidate.isValid() && !candidate.isBefore(startOfToday, 'day')) return candidate.toDate();
  }
  return null;
};

const parseGoToDate = (value, today = new Date()) => {
  if (!value || !value.trim()) return null;

  const normalized = normalize(value);
  if (!normalized) return null;

  for (const format of YEAR_FORMATS) {
    const attempt = moment(normalized, format, true);
    if (attempt.isValid()) return attempt.toDate();
  }

  const startOfToday = moment(today).startOf('day');

  for (const format of YEARLESS_FORMATS) {
    const attempt = moment(`${normalized} ${LEAP_REFERENCE_YEAR}`, `${format} YYYY`, true);
    if (attempt.isValid()) return nextOccurrence(attempt.month(), attempt.date(), startOfToday);
  }

  return null;
};

export default parseGoToDate;
